import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'FormattedLabelWithPrice',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {},
    },
    label: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 4px 0 0',
        },
      },
    },
    value: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
